import React, { useState, useEffect, useRef, useCallback } from "react"
import styled from "@emotion/styled"
import { Container } from "theme-ui"

import NavBar from "components/navigations/navbar"
import TopBar from "./topBar"

const StickyHeader = styled.header`
    box-shadow: 0 4px 13px rgb(0, 0, 0, 0.16);
    transition: background-color 0.3s ease;
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    z-index: 11;
    &.sticky {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 99;
        background-color: rgba(255, 255, 255, 0.95);
        & + div {
            padding-top: 150px;
            @media screen and (max-width: 425px) {
                padding-top: 132px;
            }
        }
    }
`

const Header = (props) => {
    const [sticky, setSticky] = useState("")
    const headerRef = useRef(null)

    const toggleSticky = useCallback(({ top, bottom }) => {
        if (top + window.scrollY <= 0 && bottom > 2 * 68) {
            setSticky("")
        } else {
            setSticky("sticky")
        }
    }, [])

    useEffect(() => {
        const handleScroll = () => {
            toggleSticky(headerRef.current.getBoundingClientRect())
        }

        document.addEventListener("scroll", handleScroll)

        return () => {
            // clean up the event handler when the component unmounts
            document.removeEventListener("scroll", handleScroll)
        }
    }, [toggleSticky])

    return (
        <StickyHeader className={sticky} ref={headerRef}>
            {/** hide topbar in mobile */}
            <TopBar company={props.company} />
            <Container>
                <NavBar />
            </Container>
        </StickyHeader>
    )
}

export default Header
